export var valuesPublicationStateEnum = ["Publicated", "NotPublicated", "Both"];
/*

*/ 
//# sourceMappingURL=PublicationStateEnum.js.map